export default "__VITE_ASSET__DTejN73u__"